import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Skeleton, TextFieldProps } from '@mui/material';

import BaseTextField from '../../../../core/presentation/components/base-text-field/base-text-field';

export type EmailTextFieldProps = TextFieldProps & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  errorText?: string;
  isLoading?: boolean;
  optional?: boolean;
};

const EmailTextField = (props: EmailTextFieldProps) => {
  const { t } = useTranslation(['login']);
  return (
    <Controller
      name={props.name ?? 'email'}
      control={props.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          {props.isLoading ? (
            <Skeleton variant='rectangular' height={56} />
          ) : (
            <BaseTextField
              onChange={onChange}
              value={value || ''}
              error={!!error}
              helperText={
                error ? props.errorText ?? t('emailInvalid') : undefined
              }
              id='email'
              name={props.name ?? 'email'}
              label={t('email')}
              variant='filled'
              type='email'
              inputProps={{ shrink: value }}
              required={!props.optional}
              {...props}
            />
          )}
        </>
      )}
    />
  );
};

export default EmailTextField;
